import script from "./OnboardingAiInviteUsersAdminInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiInviteUsersAdminInvitation.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiInviteUsersAdminInvitation.vue?vue&type=style&index=0&id=0a8566e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8566e0"]])

export default __exports__